import { format, subDays } from "date-fns"
import type { UrlFilterSchema } from "@core/hooks/useUrlFilters"
import type { Realization } from "../../interfaces/realization"
import { cleanFilters, parseDateParam } from "./filterUrl"

export const REALIZATION_FILTER_SCHEMA = {
  categories: "numberArray",
  products: "numberArray",
  statuses: "stringArray",
  couriers: "numberArray",
  cities: "numberArray",
  batches: "numberArray",
  start: "string",
  end: "string",
} as const satisfies UrlFilterSchema

const normalizeDate = (raw: string | undefined, fallback: Date): string => {
  const date =
    raw && /^\d{4}-\d{2}-\d{2}$/.test(raw)
      ? (parseDateParam(raw, fallback) ?? fallback)
      : fallback

  return format(date, "yyyy-MM-dd")
}

export const getInitialRealizationFilters = (
  url: Realization.RealizationQueryParams,
  now = new Date(),
): Realization.RealizationQueryParams =>
  cleanFilters({
    ...url,
    start: normalizeDate(url.start, subDays(now, 6)),
    end: normalizeDate(url.end, now),
  })
